import PieChart from "./PieChart.component.jsx";

export default PieChart;
